import type { BatchSchedule } from 'lib-shared-types-api';
import type { ReactElement } from 'react';

import { Action, useScheduleFetch } from '../hooks/useScheduleFetch';

type Props = {
  render: (schedules: BatchSchedule[]) => ReactElement;
  actions: Action[] | null;
};

export function ScheduleFetch({ render, actions }: Props): JSX.Element {
  const schedules = useScheduleFetch(actions);

  return render(schedules);
}
